// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const de = {
    'countryCode': 'de_de',
    'Accetto il regolamento fidelity e la privacy policy': 'Ich akzeptiere die Fidelity-Bestimmungen und die Datenschutzbestimmungen',
    'Account creation': 'Kontoerstellung',
    'Add address': 'Adresse hinzufügen',
    'Address': 'Adresse',
    'Address label': 'Adressenbezeichnung',
    'Address label placeholder': 'etwa: Zuhause, Arbeit ...',
    'Amount': 'Betrag',
    'Apply': 'Anwenden',
    'Apply Discount': 'Rabatt anwenden',
    'Are you sure you want to delete this item from cart': 'Sind Sie sicher, dass Sie diesen Artikel aus dem Warenkorb entfernen wollen?',
    'Are you sure you want to move this item to wishlist?': 'Möchten Sie diesen Artikel wirklich auf die Wunschliste verschieben?',
    'articles': 'Artikel',
    'articles inside': 'vorhandene Artikel',
    'Back': 'Zurück',
    'Back to cart': 'Zurück zum Warenkorb',
    'Back to shopping': 'Zurück zum Shopping',
    'Back to store': 'Zurück zum Laden',
    'Billing address': 'Rechnungsadresse',
    'Billing address is the same as the shipping address': 'Die Rechnungsadresse ist identisch mit der Lieferadresse',
    'Buy': 'Kaufen',
    'Buy Now': 'Jetzt kaufen',
    'Buy now, pay later': 'Kaufen Sie jetzt, bezahlen Sie später',
    'Cancel': 'Löschen',
    'Cannot apply Gift Card': 'Der Geschenkgutschein kann nicht angewendet werden',
    'Cannot apply glam card points': 'Die Punkte Ihrer WE Card konnten nicht genutzt werden',
    'Card issuer authentication failed': 'Authentifizierung des Kartenausstellers fehlgeschlagen',
    'Cart': 'Warenkorb',
    'Cart content': 'Warenkorbinhalt',
    'Change': 'Veränderung',
    'Change address': 'Adresse ändern',
    'Change e-mail': 'E-Mail ändern',
    'Change pickup point': 'Abholpunkt ändern',
    'Check zip code': 'Postleitzahl prüfen',
    'Choose a shipping method in order to proceed': 'Um fortzufahren, wählen Sie bitte Ihre Versandart',
    'Choose a store for the pick-up in order to proceed': 'Wählen Sie ein Geschäft für die Abholung, um fortzufahren',
    'Choose a zipcode in order to proceed': 'Wählen Sie eine Postleitzahl, um fortzufahren',
    'City': 'Stadt',
    'Close': 'Schließen',
    'Closed': 'Geschlossen',
    'Color': 'Farbe',
    'Complete your order': 'Die Bestellung abschließen',
    'Condizioni di vendita': 'Verkaufsbedingungen',
    'Confirm': 'Bestätigen',
    'Continue': 'Weiter',
    'Continue as guest': 'Als Gast fortfahren',
    'Country': 'Land',
    'Coupon': 'Coupon',
    'Coupon Code': 'Rabattcode',
    'Credit Card': 'Kreditkarte',
    'Credit Card Number': 'Kartennummer',
    'data': 'daten',
    'Date of birth': 'Geburtsdatum',
    'Date of Birth': 'Geburtsdatum',
    'dd/mm/yyyy': 'tt/mm/jjjj',
    'Delete': 'Löschen',
    'Delivery:': 'Lieferung:',
    'Description': 'Beschreibung',
    'Do you have a discount code?': 'Sie haben einen Rabattcode?',
    'Enter your Gift Card here': 'Geben Sie hier Ihren Geschenkgutschein ein',
    'do-login': 'Einloggen',
    'done': 'getan',
    'E-mail address': 'E-Mail-Adresse',
    'Edit': 'Bearbeiten',
    'Edit address': 'Adresse bearbeiten',
    'Edit Cart': 'Warenkorb bearbeiten',
    'Email': 'E-Mail',
    'Email and telephone number': 'E-Mail und Telefonnummer',
    'email-remainder': 'Wir haben Ihnen eine E-Mail zur Wiederherstellung des Passworts geschickt. Klicken Sie auf den Link in der E-Mail.',
    'Empty credit card fields': 'Bitte geben Sie die Kreditkartendaten ein',
    'Enter shipping address': 'Lieferadresse eingeben',
    'Enter the points to be used here': 'Geben Sie hier die zu verwendenden Punkte ein',
    'Error during payment authorization': 'Fehler bei der Zahlungsautorisierung',
    'Error during registration': 'Fehler bei der Registrierung',
    'Error occurred while placing orde': 'Fehler beim Aufgeben der Bestellung aufgetreten',
    'Expire Date': 'Ablaufdatum',
    'Female': 'Weiblich',
    'Firstname': 'Vorname',
    'Forgot your password?': 'Haben Sie Ihr Passwort vergessen?',
    'Free': 'Kostenlos',
    'Friday': 'Freitag',
    'From': 'Von',
    'Gender': 'Geschlecht',
    'Gift Card': 'Geschenkkarte',
    'Gift card and discount codes': 'Geschenkgutschein und Rabattcodes',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'WE Card-Rabatt',
    'glamcard-bonusapplied': 'Es wurden {bonus} Punkte Ihrer WE Card genutzt',
    'Go to checkout': 'Zur Kasse',
    'Go to payment': 'Weiter zur Bezahlung',
    'Go to shipping': 'Weiter zum Versand',
    'Go to summary': 'Zur Zusammenfassung gehen',
    'Home delivery cost': 'Kosten für die Zustellung nach Hause',
    'How many points do you want to use?': 'Wie viel Bonus möchten Sie nutzen?',
    'How much bonus do you want to use?': 'Wie viele Punkte möchten Sie nutzen?',
    'I don\'t want to receive the invoice': 'Ich möchte die Rechnung nicht erhalten',
    'I want to receive the invoice': 'Ich möchte eine Rechnung erhalten',
    'Identical to shipping address': 'Identisch mit der Lieferadresse',
    'Insert here coupon code': 'Geben Sie hier den Gutscheincode an',
    'Insert here the shipping data': 'Geben Sie hier die Versanddaten ein',
    'Insert here your email to proceed, we will send you just the order updates': 'Geben Sie Ihre E-Mail-Adresse ein, um fortzufahren. Wir senden Ihnen nur Informationen zu dieser Bestellung',
    'Insert your billing address': 'Rechnungsanschrift hier eingeben',
    'invoice': 'Zahlung',
    'Invoice address': 'Rechnungsanschrift',
    'Last name': 'Nachname',
    'Lastname': 'Nachname',
    'Leave': 'Abbrechen',
    'Loading': 'Lädt',
    'Loading payment form, please wait': 'Zahlungsformular wird geladen, bitte warten',
    'login': 'Log-in',
    'Login': 'Anmelden',
    'Male': 'Männlich',
    'Message': 'Nachricht',
    'Mobile phone': 'Telefonnummer',
    'Monday': 'Montag',
    'Move item': 'Artikel verschieben',
    'Move product': 'Produkt verschieben',
    'Name': 'Name',
    'New address': 'Neue Adresse',
    'New client': 'Neuer Kunde',
    'No items in cart': 'Der Warenkorb ist leer',
    'No near stores': 'Keine Geschäfte in der Nähe',
    'No shipping methods available': 'Keine Versandart verfügbar',
    'Not registered yet?': 'Noch nicht registriert?',
    'Ok': 'Okay',
    'Or': 'Oder',
    'Order detail': 'Bestelldetails',
    'Order details': 'Bestelldetails',
    'Order placed': 'Bestellung abgeschlossen. Sofort werden Sie auf die Übersichtsseite weitergeleitet',
    'Order will be shipped to': 'Die Bestellung wird gesendet an',
    'Password': 'Passwort',
    'Password confirm': 'Passwort bestätigen',
    'Pay': 'Bezahlen',
    'payment': 'Zahlung',
    'Payment': 'Zahlung',
    'Payment error.': 'Zahlungsfehler.',
    'Payment method': 'Zahlungsmethode',
    'Payment method not supported': 'Zahlungsmethode nicht unterstützt',
    'Personal data': 'Persönliche Daten',
    'Place of birth': 'Geburtsort',
    'Place of Birth': 'Geburtsort',
    'Please select shipping from Amazon widget': 'Bitte wählen Sie den Versand über das Amazon-Widget',
    'Please try again with another form of payment': 'Bitte versuchen Sie es erneut mit einer anderen Zahlungsart',
    'Please wait': 'Bitte warten',
    'Please wait, payment is processing': 'Bitte warten Sie, die Zahlung wird gerade verarbeitet',
    'Postcode': 'PLZ',
    'Prefix': 'Präfix',
    'Proceed': 'Weiter',
    'Proceed delete': 'Fortfahren',
    'Proceed to payment': 'Weiter zur Zahlung',
    'Proceed with the purchase': 'Weiter einkaufen',
    'product': 'produkt',
    'Product': 'Produkt',
    'products': 'produkte',
    'Products total': 'Artikel gesamt',
    'Quantity': 'Menge',
    'Register': 'Jetzt registrieren',
    'Registered User': 'registrierter Nutzer',
    'Registration agreement': 'Registrierungsvereinbarung',
    'Registration successful': 'Registrierung erfolgreich',
    'registrationagreement': 'Ich akzeptiere die <a href="{linkfid}" target="_blank">Fidelity-Bestimmungen</a> und die <a href="{linkpriv}" target="_blank">Datenschutzbestimmungen</a>',
    'Remove': 'Entfernen',
    'Remove Discount': 'Rabatt entfernen',
    'Remove the item': 'Den Artikel entfernen',
    'Required fields': 'Benötigte Felder',
    'Retry': 'Noch einmal versuchen',
    'review': 'Zusammenfassung',
    'Safe purchase': 'sicherer kauf',
    'Same as billing': 'Dieselbe wie die Rechnungsanschrift',
    'Saturday': 'Samstag',
    'Save': 'Speichern',
    'Save address': 'Adresse speichern',
    'Save in address book': 'Im Adressbuch speichern',
    'Save new address to proceed': 'Neue Adresse speichern, um fortzufahren',
    'Select': 'Auswählen',
    'Select a city': 'Wählen Sie die Stadt',
    'Select a payment method': 'Wählen Sie eine Zahlungsmethode',
    'Select a region': 'Wählen Sie die Region',
    'Select an address': 'Wàhlen Sie eine Adresse',
    'Select here your shipping address': 'Wählen Sie hier Ihre Lieferadresse',
    'Select payment method': 'Wählen Sie eine Zahlungsmethode',
    'Select region': 'Wählen Sie die Region',
    'Select shipping method': 'Wählen Sie eine Versandart',
    'Select store pickup': 'Abholung im Geschäft auswählen',
    'Select store pickup to procede': 'Wählen Sie die Abholung im Geschäft, um fortzufahren',
    'Select the store': 'Wählen Sie das Geschäft aus',
    'Select this store': 'Diesen Shop auswählen',
    'Select value': 'Wählen Sie einen Wert',
    'Selected Store': 'Geschäft gewählt',
    'Seleziona il metodo di spedizione': 'Wählen Sie Versandart',
    'Send remainder': 'E-Mail zur Wiederherstellung des Passworts senden',
    'Service unavailable, retry later': 'Vorübergehender Fehler bei der Anfrage. Versuchen Sie es später noch einmal',
    'Session expired, page will reload': 'Sitzung ist abgelaufen, die Seite wird neu geladen',
    'shipping': 'Versand',
    'Shipping': 'Versand',
    'Shipping address': 'Lieferadresse',
    'Shipping and handling': 'Versand und Bearbeitung',
    'Shipping data': 'Versanddaten',
    'Shipping informations': 'Versandinformationen',
    'Shop opening hours': 'Geschäftszeiten des Shops',
    'Shopping Cart': 'Warenkorb',
    'shopping details': 'Kaufdaten',
    'Size': 'Größe',
    'Something went wrong during Yandex Checkout': 'Beim Yandex-Checkout ist etwas schief gelaufen',
    'State/Region': 'Provinz',
    'Store selection': 'Wahl des Geschäfts',
    'street': 'Straße',
    'Street': 'Straße',
    'Street number': 'Hausnummer',
    'Sunday': 'Sonntag',
    'Surname': 'Nachname',
    'Tax included': 'Steuern inbegriffen',
    'Telephone': 'Telefon',
    'Telephone number': 'Telefonnummer',
    'Telephone number for courier / store pickup': 'Telefonnummer für Kurier-/Geschäftsabholung',
    'Terranova stores near you': 'Terranova Stores in deiner Nähe',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Der Gutschein ist nicht gültig. Überprüfen Sie den Code und versuchen Sie es erneut.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Die Geschenkkarte ist ungültig oder leer. Bitte überprüfen Sie den Geschenkgutschein und versuchen Sie es erneut',
    'The maximum value of the usable We+Card bonus is': 'Der nutzbare Höchstwert des WE Card-Bonus ist',
    'The maximum value of the usable WE+Card points is': 'Der maximale Wert der nutzbaren WE-Card-Punkte beträgt',
    'The order is already been paid, please wait while order is placing': 'Die Bestellung wurde bereits bezahlt, bitte warten Sie, bis die Bestellung bestätigt ist',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Das Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen (.;,!$#) enthalten.',
    'The requested qty is not available': 'Die angeforderte Menge ist nicht verfügbar',
    'There has been an error. Please try again': 'Es ist ein Fehler aufgetreten Bitte versuchen Sie es erneut',
    'This email already esists. Do the login or proceed as guest': 'Diese E-Mail existiert bereits. Melden Sie sich an oder fahren Sie als Gast fort',
    'This product is not available, please remove it from cart to proceed': 'Dieser Artikel ist nicht verfügbar. Bitten entfernen Sie ihn aus dem Warenkorb, um fortzufahren',
    'Thursday': 'Donnerstag',
    'To': 'An',
    'Total': 'Gesamt',
    'Tuesday': 'Dienstag',
    'Type of card': 'Kartentyp',
    'Update address': 'Adresse aktualisieren',
    'Use Glam Card Bonus': 'WE Card-Bonus nutzen',
    'Use points': 'Bonus nutzen',
    'Use WE+ points': 'WE+ Punkte nutzen',
    'User': 'Benutzer',
    'Valid until': 'Gültig bis',
    'VAT number': 'USt-IdNr.',
    'Verify billing address': 'Überprüfen Sie die Rechnungsadresse',
    'Verify Gift Card': 'Geschenkkarte bestätigen',
    'Verify payment method selection': 'Überprüfen Sie die Auswahl der Zahlungsmethode',
    'Verify shipping address': 'Überprüfen Sie die Lieferadresse',
    'Verify shipping method selection': 'Überprüfen Sie die Auswahl der Versandart',
    'View your cart': 'Warenkorb ansehen',
    'Wait for page to reload': 'Warten Sie, bis die Seite neu geladen wurde',
    'We\'re unable to send the password reset email': 'Die E-Mail zur Wiederherstellung des Passworts konnte nicht verschickt werden. Bitte überprüfen Sie die eingegebe E-Mail',
    'Wednesday': 'Mittwoch',
    'You are ordering with this email address': 'Sie bestellen mit dieser E-Mail-Adresse',
    'You are shipping in a foreign country': 'Sie versenden ins Ausland',
    'Your available points': 'Ihre verfügbaren Punkte',
    'Your avalaible bonus': 'Verfügbarer Bonus',
    'Zip code': 'PLZ',
    'Zip or city': 'Postleitzahl oder Stadt',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Versandkosten ausgeschlossen',
    'Extra address': 'Zusätzliche Informationen (freigestellt)',
    'Extra address placeholder': 'C/O Wohnungsnummer, Ortsteil, Name auf der Gegensprechanlage',
    '8 characters': '8 Zeichen',
    '1 lowercase letter': '1 Kleinbuchstabe',
    '1 uppercase letter': '1 Großbuchstabe',
    '1 number': '1 Zahl',
    '1 special character': '1 Sonderzeichen',
    'Now you can use your points': 'Jetzt können Sie Ihre Punkte nutzen',
    'Hallo': 'Hallo',
    'Save Credit Card (One Click Payment)': 'Kreditkarte speichern (Zahlung mit einem Klick)',
    'Pay with a saved credit card': 'Bezahlen mit einer gespeicherten Kreditkarte',
    'Pay with a new credit or debit card': 'Bezahlen Sie mit einer neuen Kredit- oder Debitkarte',
    'Expiration': 'Bezahlen mit einer gespeicherten Kreditkarte',
    'Other': 'Andere',
    'Applied discounts': 'Angewendete Rabatte',
    'Choose size': 'Größe wählen',
    'Municipality': 'Gemeinde',
    'amount-for-freeshipping': 'Ihnen fehlen {amount} für den kostenlosen Versand durch einen Kurierdienst',
    'To proceed you must select a payment method': 'Um fortzufahren, müssen Sie eine Zahlungsmethode auswählen',
    'To proceed you need to save the selected billing address': 'Um fortzufahren, müssen Sie die ausgewählte Rechnungsadresse speichern',
    'To proceed it is necessary to accept the general conditions of sale': 'Um fortzufahren, ist es erforderlich, den Allgemeinen Verkaufsbedingungen zuzustimmen',
    'To proceed you need to select the store': 'Um fortzufahren, müssen Sie das Geschäft auswählen',
    'To proceed you need to save your changes': 'Um fortzufahren, müssen Sie Ihre Änderungen speichern',
    'Are you sure you want to delete this address?': 'Möchten Sie diese Adresse wirklich löschen?',
    'To proceed you need to save the selected shipping address': 'Um fortzufahren, müssen Sie die ausgewählte Lieferadresse speichern',
    'message-double_optin_using_point_disabled': 'Sie können für diesen Kauf keine Punkte einlösen, da Sie die Gültigkeit Ihrer E-Mail oder Telefonnummer noch nicht bestätigt haben. Wenn Sie Fragen haben, wenden Sie sich bitte an unseren Kundendienst.',
}
export default de;
export const deValidation = {
    name: "de",
    messages: {
        _default: function (e: any) {
            return "Der Wert des Feldes " + e + " ist ungültig."
        },
        after: function (e: any, n: any) {
            return "Der " + e + " muss nach " + n[0] + "stehen."
        },
        alpha: function (e: any) {
            return "Das Feld " + e + " darf nur alphanumerische Zeichen enthalten."
        },
        alpha_dash: function (e: any) {
            return "Das Feld " + e + " darf nur alphanumerische Zeichen sowie Striche und Unterstriche enthalten."
        },
        alpha_num: function (e: any) {
            return "Das Feld " + e + " darf nur alphanumerische Zeichen enthalten."
        },
        alpha_spaces: function (e: any) {
            return "Das Feld " + e + " darf nur alphanumerische Zeichen sowie Leerzeichen enthalten."
        },
        before: function (e: any, n: any) {
            return "Das Feld " + e + " muss vor " + n[0] + "stehen."
        },
        between: function (e: any, n: any) {
            return "Das Feld " + e + " muss zwischen " + n[0] + " e " + n[1] + "stehen."
        },
        confirmed: function (e: any, n: any) {
            return "Das Feld " + e + " ist nicht identisch mit " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Das Feld " + e + " ist nicht gültig."
        },
        date_between: function (e: any, n: any) {
            return "Das " + e + " muss zwischen " + n[0] + " e " + n[1] + "stehen."
        },
        date_format: function (e: any, n: any) {
            return "Das " + e + " muss im Format " + n[0] + "angegeben werden."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Das Feld " + e + " muss numerisch sein und darf" + (r && "*" !== r ? " " + r : "") + " Dezimalzeichen enthalten."
        },
        digits: function (e: any, n: any) {
            return "Das Feld " + e + " mus numerisch sein und genau " + n[0] + " Ziffern enthalten."
        },
        dimensions: function (e: any, n: any) {
            return "Das Feld " + e + " muss " + n[0] + " x " + n[1] + "sein."
        },
        email: function (e: any) {
            return "Das Feld " + e + " muss eine gültige E-Mail-Adresse enthalten."
        },
        excluded: function (e: any) {
            return "Das Feld " + e + " muss einen gültigen Wert enthalten."
        },
        ext: function (e: any) {
            return "Das Feld " + e + " muss eine gültige Datei enthalten."
        },
        image: function (e: any) {
            return "Das Feld " + e + " muss ein Bild enthalten."
        },
        included: function (e: any) {
            return "Das Feld " + e + " muss einen gültigen Wert enthalten."
        },
        ip: function (e: any) {
            return "Das Feld " + e + " muss eine gültige IP-Adresse enthalten."
        },
        length: function (e: any, n: any) {
            return "Die Länge des Feldes " + e + " muss " + n[0] + " sein."
        },
        max: function (e: any, n: any) {
            return "Das Feld " + e + " darf nicht mehr als" + n[0] + " Zeichen enthalten."
        },
        max_value: function (e: any, n: any) {
            return "Das Feld " + e + " muss kleiner sein als oder gleich " + n[0]
        },
        mimes: function (e: any) {
            return "Das Feld " + e + " muss eine gültige Datei enthalten."
        },
        min: function (e: any, n: any) {
            return "Das Feld " + e + " muss mindestens " + n[0] + " Zeichen enthalten."
        },
        min_value: function (e: any, n: any) {
            return "Das Feld " + e + " muss kleiner sein als oder gleich " + n[0]
        },
        numeric: function (e: any) {
            return "Das Feld " + e + " darf nur numerische Zeichen enthalten."
        },
        regex: function (e: any) {
            return "Das Feld " + e + " hat kein gültiges Format."
        },
        required: function (e: any) {
            return "Das Feld " + e + " ist erforderlich."
        },
        size: function (e: any, n: any) {
            return "Das Feld " + e + " muss kleiner sein als " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Das Feld " + e + " ist keine gültige URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'Ungültige Umsatzsteuer-Identifikationsnummer/Steuerkennzeichen.';
        },
        'validate-regionid': function (e: any) {
            return 'Das Feld Region ist erforderlich.';
        },
        'validate-ascii': function(e: any) {
            return 'This field cannot contains special charachters';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Für die Verarbeitung personenbezogener Daten ist Ihre Zustimmung erforderlich.';
        },
        'validate-gender': function(e: any) {
            return 'Das Feld Geschlecht ist erforderlich.';
        },
        'validate-password': function(e: any) {
            return 'Das Passwort muss mindestens 8 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen (.;,!$#) enthalten.';
        },
    },
    attributes: {}
};
